export const TAXONOMY_MULTISELECT_DELIMITER = ';';
export const TAXONOMY_SKIP_SEGMENT = 'all';
export const FILTER_PATH_SEPARATOR = '/-/';
